import SubjectIcon from '@mui/icons-material/Subject'; // Or any other icon you prefer
import { Box, Typography } from "@mui/material";
import { useStore } from "@priolo/jon";
import FormParagraph from "components/controls/form/FormParagraph";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import detailSo from "stores/task/taskDetail";



const TaskSubTab:FunctionComponent = () => {

	// STORE
	const detailSa = useStore(detailSo)

	// HOOKs
	const { t } = useTranslation()

	// HANDLERs

	// RENDER 
	const subtasks = detailSa.select?.subtasks
	if (!subtasks || subtasks.length == 0) return (
		<Typography align="center" style={{ marginTop: "60px" }}>
			{t("dialog.task.subtasks.void")}
		</Typography>
	)

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
			{subtasks.map((subtask, index) => (
				<FormParagraph compact
					key={subtask.id ?? index}
					title={subtask.subject}
					icon={<SubjectIcon />}
				>
					<Typography sx={{ mb: 1.5, whiteSpace: 'pre-line' }} color="text.secondary">
						{subtask.description}
					</Typography>
					{subtask.input && (
						<Typography variant="body2">
							<strong>INPUT:</strong> {subtask.inputValue}
						</Typography>
					)}
				</FormParagraph>
			))}
		</Box>
	)
}

export default TaskSubTab
